export const findTab = (path: string, items: { to: string }[]) => {
    if (path.length > 1) {
        let tabs = path.split('/');
        tabs.shift();
        tabs[0] = '/' + tabs[0];

        let same = items.filter(item => tabs.includes(item.to));
        
        return same.length ? same[0].to : items[0].to;
    }else{
        return items[0].to;
    }

    // return items[0].to;
};